// Splide bundle entry
import './module/custom-splider';
